import { render, staticRenderFns } from "./UITag.vue?vue&type=template&id=1bec17b8&scoped=true"
import script from "./UITag.vue?vue&type=script&lang=js"
export * from "./UITag.vue?vue&type=script&lang=js"
import style0 from "./UITag.vue?vue&type=style&index=0&id=1bec17b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec17b8",
  null
  
)

export default component.exports